import { useCallback, useState } from "react";
import { downloadProcedureGroupGeneralProceduresExcelByFormEvent } from "../../_events/procedure_group/find.event";
import { downloadCompetencyGroupIndividualProceduresExcelByFormEvent } from "../../_events/competency-group/find.event";
import { downloadExcelStudentsByFormEvent } from "../../_events/academic_parts/find.event";
import { alertError } from "../../_utils/alerts";

export const useDownloadReports = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadProcedureGroupGeneralProceduresExcelByForm = useCallback(
    async (data) => {
      setIsDownloading(true);
      downloadProcedureGroupGeneralProceduresExcelByFormEvent(data.uuid)
        .catch((err) => {
          alertError(err.message);
        })
        .finally(() => {
          setIsDownloading(false);
        });
    },
    [],
  );

  const downloadCompetencyGroupIndividualProceduresExcelByForm = useCallback(
    async (data) => {
      setIsDownloading(true);
      downloadCompetencyGroupIndividualProceduresExcelByFormEvent(data.uuid)
        .catch((err) => {
          alertError(err.message);
        })
        .finally(() => {
          setIsDownloading(false);
        });
    },
    [],
  );

  const downloadExcelStudentsByForm = useCallback(async (data) => {
    setIsDownloading(true);
    downloadExcelStudentsByFormEvent(data.uuid)
      .catch((err) => {
        alertError(err.message);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  }, []);

  return {
    isDownloading,
    downloadProcedureGroupGeneralProceduresExcelByForm,
    downloadCompetencyGroupIndividualProceduresExcelByForm,
    downloadExcelStudentsByForm,
  };
};
